import { api } from "../utils/AuthManager";

const PostClientPackage = async (id, formData) => {
  return api
    .post(`/api/client_package/${id}/`, formData)

    .then((res) => {
      return res;
    })
    .catch((err) => {
      return Promise.reject(err);
    });
};

export default PostClientPackage;
